/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SendingInputs */

const th_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังส่ง…`)
};

const en_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const ja_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信しています…`)
};

const zh_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发送…`)
};

const es_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const pt_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const id_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengirim…`)
};

const fr_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const tl_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipinapadala…`)
};

const vi_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang gửi…`)
};

const ko_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보내는 중…`)
};

const de_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

const ru_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправляем…`)
};

const tr_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderiliyor…`)
};

const it_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio…`)
};

const pl_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłanie…`)
};

const uk_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надсилаємо…`)
};

const hi_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भेजा जा रहा है…`)
};

const ar_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الإرسال…`)
};

const ms_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menghantar…`)
};

const bn_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠানো হচ্ছে…`)
};

const zh_tw2_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄送中…`)
};

const zh_hk2_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄送中…`)
};

const ur_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بھیجا جا رہا ہے…`)
};

const fa_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال فرستادن…`)
};

const sw_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inatumwa…`)
};

const nl_sending = /** @type {(inputs: SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met versturen…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {SendingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sending = /** @type {((inputs?: SendingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SendingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sending(inputs)
	if (locale === "ja") return ja_sending(inputs)
	if (locale === "zh") return zh_sending(inputs)
	if (locale === "es") return es_sending(inputs)
	if (locale === "pt") return pt_sending(inputs)
	if (locale === "id") return id_sending(inputs)
	if (locale === "fr") return fr_sending(inputs)
	if (locale === "tl") return tl_sending(inputs)
	if (locale === "vi") return vi_sending(inputs)
	if (locale === "ko") return ko_sending(inputs)
	if (locale === "de") return de_sending(inputs)
	if (locale === "ru") return ru_sending(inputs)
	if (locale === "tr") return tr_sending(inputs)
	if (locale === "it") return it_sending(inputs)
	if (locale === "pl") return pl_sending(inputs)
	if (locale === "uk") return uk_sending(inputs)
	if (locale === "hi") return hi_sending(inputs)
	if (locale === "ar") return ar_sending(inputs)
	if (locale === "ms") return ms_sending(inputs)
	if (locale === "bn") return bn_sending(inputs)
	if (locale === "zh-TW") return zh_tw2_sending(inputs)
	if (locale === "zh-HK") return zh_hk2_sending(inputs)
	if (locale === "ur") return ur_sending(inputs)
	if (locale === "fa") return fa_sending(inputs)
	if (locale === "sw") return sw_sending(inputs)
	if (locale === "nl") return nl_sending(inputs)
	return en_sending(inputs)
});